import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Typography, Alert } from '@mui/material';
import { CheckCircle, Error as ErrorIcon } from '@mui/icons-material';

const GoogleCalendarCallbackPage: React.FC = () => {
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('Completamento autenticazione...');

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const success = urlParams.get('success');
    const error = urlParams.get('error');

    if (error) {
      setStatus('error');
      setMessage('Autenticazione annullata o fallita');

      // Notifica la finestra principale dell'errore
      if (window.opener && !window.opener.closed) {
        window.opener.postMessage(
          { type: 'GOOGLE_CALENDAR_AUTH_ERROR', error },
          window.location.origin
        );
      }

      // Chiudi il popup dopo 2 secondi
      setTimeout(() => {
        window.close();
      }, 2000);
    } else if (success === 'true') {
      // Il backend ha processato il callback con successo
      setStatus('success');
      setMessage('Google Calendar connesso con successo!');

      // Notifica la finestra principale del successo
      if (window.opener && !window.opener.closed) {
        window.opener.postMessage(
          { type: 'GOOGLE_CALENDAR_AUTH_SUCCESS' },
          window.location.origin
        );
      }

      // Chiudi il popup dopo 1.5 secondi
      setTimeout(() => {
        window.close();
      }, 1500);
    } else {
      setStatus('error');
      setMessage('Parametri di autenticazione mancanti');

      // Chiudi il popup dopo 2 secondi
      setTimeout(() => {
        window.close();
      }, 2000);
    }
  }, []);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      p={4}
    >
      {status === 'loading' && (
        <>
          <CircularProgress size={60} />
          <Typography variant="h6" mt={3}>
            {message}
          </Typography>
        </>
      )}

      {status === 'success' && (
        <>
          <CheckCircle color="success" sx={{ fontSize: 80 }} />
          <Alert severity="success" sx={{ mt: 3 }}>
            <Typography variant="h6">{message}</Typography>
            <Typography variant="body2" mt={1}>
              Questa finestra si chiuderà automaticamente...
            </Typography>
          </Alert>
        </>
      )}

      {status === 'error' && (
        <>
          <ErrorIcon color="error" sx={{ fontSize: 80 }} />
          <Alert severity="error" sx={{ mt: 3 }}>
            <Typography variant="h6">{message}</Typography>
            <Typography variant="body2" mt={1}>
              Questa finestra si chiuderà automaticamente...
            </Typography>
          </Alert>
        </>
      )}
    </Box>
  );
};

export default GoogleCalendarCallbackPage;